<div class="modal-clean modal-clean--wide modal-upgrade-ads --centered">
    <div class="modal-clean__content --no-outer-padding" *ngIf="!isSubscribed && tier && selectedProduct">
        <div class="modal-clean__header">
            <div class="modal__close" (click)="close()"></div>
        </div>
        <div class="modal-upgrade-ads__top">
            <div class="modal-upgrade-ads__title">{{ adSupportedCohortConfig?.title }}</div>
            <div class="modal-upgrade-ads__subtitle">{{ adSupportedCohortConfig?.subTitle }}</div>
        </div>

        <div class="modal-upgrade-ads__visual">
            <img src="/assets/images/ads.png" alt="Upgrade to ad-free experience" />
        </div>

        <div class="modal-upgrade-ads__plan-heading">{{ tier?.tierDescription }}</div>

        <div class="modal-upgrade-ads__plans">
            <button
                type="button"
                class="modal-upgrade-ads__plans__item"
                *ngFor="let product of getOrderedProducts()"
                (click)="selectProduct(product)"
                [ngClass]="{ '--selected': selectedProduct?.id === product.id }">
                <div class="modal-upgrade-ads__plans__item__left">
                    <div class="modal-upgrade-ads__plans__item__name">
                        {{ product.title }}
                        <span class="__featured" *ngIf="product?.featuredTitle">{{ product?.featuredTitle }}</span>
                    </div>
                    <div class="modal-upgrade-ads__plans__item__saving">
                        <span class="__strike" *ngIf="product?.projectedStrikethroughPrice">{{
                            product?.projectedStrikethroughPrice
                        }}</span>
                        <span> {{ product?.yearlyPrice }}/year </span>
                        <span class="__percent" *ngIf="product?.savingPercentage"
                            >SAVE {{ product?.savingPercentage }}</span
                        >
                    </div>
                </div>
                <div class="modal-upgrade-ads__plans__item__right">
                    <span class="__price">{{ getPerMonthPrice(product) }}</span>
                    <span class="__period">/month</span>
                    <span class="__radio"></span>
                </div>
            </button>
        </div>

        <div class="modal-upgrade-ads__features">
            <div class="modal-upgrade-ads__features__item" *ngFor="let feature of tier?.contentIncluded">
                <span class="__icon">✓</span>
                <span class="__text"
                    ><span class="--highlight">{{ feature.value }}</span> {{ feature.label }}</span
                >
            </div>
        </div>
        <div class="modal-upgrade-ads__terms">
            <span class="--heading">Terms & conditions:</span> {{ adSupportedCohortConfig?.disclaimer }}
        </div>

        <div class="modal-upgrade-ads__footer" [ngClass]="{ '--disabled': disablePurchase }">
            <button
                *ngIf="!disablePurchase"
                class="button-v2 --purple --rounded --medium --wide"
                (click)="purchase(selectedProduct)">
                {{ getCTA() }}
            </button>
            <div class="modal-upgrade-ads__footer__meta" *ngIf="!disablePurchase">
                {{ getSelectedPlanFooterText() }}
            </div>
            <div class="modal-upgrade-ads__footer__purchase-instruction" *ngIf="disablePurchase">
                Upgrade in your settings once you’ve finished your call!
            </div>
        </div>
    </div>
</div>
